import { Text, TextProps } from "@mantine/core"
import { Missing } from "@tfg/ui"
import dayjs from "dayjs"

type Props = TextProps & {
  date?: Date | string | null
  format?: string
  textOnly?: boolean
}

export const DateCell = ({ date, format = "ll", ...textProps }: Props) => {
  if (!date) return <Missing {...textProps} />
  return (
    <Text style={{ whiteSpace: "nowrap" }} {...textProps}>
      {dayjs(date).format(format)}
    </Text>
  )
}

export const DateCellItemInfo = ({
  date,
  format = "YYYY-MM-DD",
  textOnly,
  ...textProps
}: Props) => {
  if (!date) return <Missing {...textProps} />
  if (textOnly) return <>{dayjs(date).format(format)}</>
  return (
    <Text style={{ whiteSpace: "nowrap" }} {...textProps}>
      {dayjs(date).format(format)}
    </Text>
  )
}
